import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import resourcesToBackend from "i18next-resources-to-backend"
import ChainedBackend from "i18next-chained-backend"
import moment from "moment"
import "moment/locale/en-ca"
import "moment/locale/fr-ca"
import "dayjs/locale/fr-ca"
// import LocalStorageBackend from "i18next-localstorage-backend"

export default function initI18n() {
  i18n
    .use(LanguageDetector)
    .use(ChainedBackend)
    .use(initReactI18next)
    .use({
      type: "postProcessor",
      name: "lettersCase",
      process: function (value: string, key: any, options: any) {
        const lettersCase = options.lettersCase ?? "capitalize"
        switch (lettersCase) {
          case "lowercase":
            return value.toLowerCase()
          case "uppercase":
            return value.toUpperCase()
          case "capitalize":
            return `${value.charAt(0).toUpperCase()}${value
              .slice(1)
              .toLowerCase()}`
          case "capitalizeFirst":
            return `${value.charAt(0).toUpperCase()}${value.slice(1)}`
          case "none":
            return value
          default:
            return "No case matched"
        }
      },
    })

    .init({
      nonExplicitSupportedLngs: true,
      load: "languageOnly",
      supportedLngs: ["en", "fr"],
      lng: localStorage.getItem("i18nextLng") || "fr",
      fallbackLng: "fr",
      fallbackNS: "translation",
      returnObjects: true,
      postProcess: "lettersCase",

      backend: {
        // TODO caching
        backends: [
          // ...(import.meta.env.NODE_ENV !== "development"
          //   ? [LocalStorageBackend]
          //   : []),
          resourcesToBackend((language, namespace, callback) => {
            import(`../locales/${language}/${namespace}.json`)
              .then((resources) => {
                const res = JSON.parse(JSON.stringify(resources.default || resources));
                
                if (res.client_specific) {
                  if (import.meta.env.VITE_APP_INTERAC_PEYMENT_RECIPIENT) {
                    res.client_specific.interac_payment_recipient = import.meta.env.VITE_APP_INTERAC_PEYMENT_RECIPIENT;
                  }
                  if (import.meta.env.VITE_APP_INTERAC_CODE) {
                    res.client_specific.interac_code = import.meta.env.VITE_APP_INTERAC_CODE;
                  }
                }
                
                callback(null, res)
              })
              .catch((error) => {
                callback(error, null)
              })
          }),
        ],
        backendOptions: [
          {
            versions: { en: "0.1.0-rc.1", fr: "0.1.0-rc.1" },
          },
        ],
      },
      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    })
}

moment.locale(i18n.language)
i18n.on("languageChanged", (lng) => {
  moment.locale(lng)
})
